<template>
  <div class="quizzes-wrapper">
    <div class="bkw-dialog-wrap" ref="wrap">
      <div class="ready" v-if="isSceneReady">
        <h2>{{title}}</h2>
        <h2>{{subtitle}}</h2>
        <br />
        <div class="button-wrapper">
          <el-button class="btn btn-orange-square" @click="startLearn">
            {{type == 'test'? '开始测试' : '开始学习'}}
          </el-button>
        </div>
      </div>
      <template v-if="isScenePlaying">
        <div class="time" v-if="isExam">{{secondsToTime}}</div>
        <!-- <p class="tip-line">{{ description }}</p> -->
        <van-quizzes-controller
            ref="controller"
            :is-exam="isExam"
            :exercises="newQuizzes"
            :user-answer="userAnswer"
            :play-times="playTimes"
            :type="type"
            :status="status"
            @change="handleChange"
            @finish="handleFinished"
            @exerciseChange="exerciseChange"
        />
      </template>
      <template v-if="isSceneKyView">
        <van-quizzes-ky-detail
            :exercises="kyExercises"
            :times="repeatTimes"
            :score="kyScore"
            :is-pass="isPass"
            :is-continue="isContinue"
            :status="status"
            @again="handleKyAgain"
            @submit="handleKySubmit"
            @exit="close"
            @continue="handleKyContinue"
        />
      </template>
      <div class="ready" v-if="isSceneError">
        <h2>{{errMsg || '哎呦~好像网络出了问题，请点击下面的重试按钮。'}}</h2>
        <br />
        <div>
          <el-button type="primary" size="small" round v-if="!errCode" @click="retry">
            重试
          </el-button>
        </div>
      </div>
      <van-exam-list
        v-if="isSceneExamList"
        :results="filterResult.length ? filterResult : results"
        ref="examList"/>
    </div>
    <van-answer-card
      class="answer-card"
      v-if="isShowAnswerCard && !isSceneError"
      :is-exam="isSceneFinished"
      :show-detail="false"
      :show-tagline="false"
      :title="navigation"
      :score="score"
      :total="results.length"
      :results="results">
      <div class="detail" :class="{ 'exam-detail': isSceneFinished }" slot="detail">
        <div class="item" v-for="(item, index) in answerCardData" :key="index">
          <div class="tag">
            <el-tag plain size="small">{{quizName[item.code][item.mode]}}</el-tag>
          </div>
          <span class="number"
                :class="{
                  filled: results[answer.index].isComplete,
                  success: results[answer.index].isRight && isSceneFinished,
                  danger: !results[answer.index].isRight && isSceneFinished,
                }"
                @click="selectExercise(answer.index)"
                v-for="(answer, number) in item.quizzes"
                :index="number"
                :global-index="getGlobalQuizIndex(index, number)"
                :key="answer.index">{{number + 1}}</span>
        </div>
      </div>
    </van-answer-card>
    <van-footer-bar
      class="exam-control"
      v-if="isExam && !isSceneReady"
      :is-exam="isExam"
      :is-show-bottom-control="true"
      :is-show-tip="false"
      :is-exam-records="isExamRecords"
      :is-disabled-replay="isDisabledReplay"
      :is-show-answer-card="isShowAnswerCard"
      :is-show-replay="score < 100 && isShowReplay"
      :total="results.length"
      :finished-text="finishedText"
      :current="exerciseIndex"
      :currentExercise="currentExercise"
      :is-show-speaker="
        !!(currentExercise.code !== 'DCPX'
        && currentExercise.code !== 'THXZ'
        && !isSelectWord
        && currentExercise.code !== 'DCTX' && currentExercise.audio)"
      :is-show-eraser="!!(currentExercise.code === 'HYDC' || currentExercise.code === 'JXZH')"
      :scene="scene"
      :results="results"
      @replay="replay"
      @speak="speak"
      @finished="finishedExam"
      @submit="handleSubmitExamBtn"
      @back="backFinishedScene"
      @detail="detail"
      @clear="clear"
      @prev="prev"
      @next="next"
      @toggleCheckType="handlerFilterResult">
      <div
        class="footer-button-wrapper"
        slot="foot">
        <el-button
          class="btn btn-orange-square"
          v-if="isShowCertificate"
          @click="openCertificate">
          查看证书
        </el-button>
      </div>
    </van-footer-bar>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import {
  RadioGroup,
  RadioButton,
  Button,
  Tag,
} from 'element-ui';
import VanDialog from '@/components/common/Dialog.vue';
import VanQuizzesToolbar from '@/components/quizzes/QuizzesToolbar.vue';
import VanExamList from '@/components/quizzes/bkw/ExamDetail.vue';
import VanQuizzesController from '@/components/quizzes/bkw/EnglishQuizzes.vue';
import VanFooterBar from '@/components/common/FooterBar.vue';
import VanAnswerCard from '@/components/common/AnswerCard.vue';
import VanQuizzesKyDetail from '@/components/quizzes/bkw/KyDetail.vue';
import utils from '@/services/utils';

const SCENE = Object.freeze({
  ready: 1,
  playing: 2,
  finished: 3,
  examList: 4,
  kyView: 5, // 人机对话附属页面
  error: 6,
  empty: 7,
});

export default {
  components: {
    ElRadioGroup: RadioGroup,
    ElRadioButton: RadioButton,
    VanDialog,
    VanQuizzesToolbar,
    VanQuizzesController,
    VanQuizzesKyDetail,
    VanFooterBar,
    VanAnswerCard,
    ElButton: Button,
    ElTag: Tag,
    VanExamList,
  },
  props: {
    navigation: {
      type: String,
      default: '',
    },
    isExamRecords: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
    },
    learnMode: {
      type: String,
    },
    subtitle: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    quizzes: {
      type: Array,
      default: () => ([]),
    },
    playTimes: {
      type: Number,
      default: 1,
    },
    status: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      quizName: {
        CHXZ: {
          1: '词汇选择（选解释）',
          2: '词汇选择（选单词）',
          3: '听音选词',
          4: '听音选义',
        },
        DX: {
          0: '单项选择',
        },
        HYDC: {
          0: '还原单词',
        },
        DCTX: {
          0: '单词听写',
        },
        SK: {
          1: '闪卡练习（学习模式）',
          2: '闪卡练习（抄写模式）',
          3: '闪卡练习（录音模式）',
        },
        HYDX: {
          0: '还原单词',
        },
        DCPX: {
          1: '单词拼写（随机模式）',
          2: '单词拼写（默写模式）',
          3: '单词拼写（自定义模式）',
        },
        TYLJ: {
          0: '听音连句',
        },
        BQWZ: {
          0: '补全文章',
        },
        JXZH: {
          0: '句型转换',
        },
        QHLJ: {
          1: '强化炼句（简单模式）',
          2: '强化炼句（复杂模式）',
          3: '强化炼句（默写模式）',
          4: '强化炼句（自定义模式）',
        },
        YDLJ: {
          0: '阅读理解',
        },
        XCTK: {
          0: '选词填空',
        },
        THXZ: {
          0: '听后选择',
        },
        WXTK: {
          0: '完形填空',
        },
      },
      scene: SCENE.ready,
      result: [],
      seconds: 0,
      mode: '', // replay 错题再练
      newQuizzes: [],
      results: [],
      answerCardData: [],
      score: 0,
      currentExercise: {},
      exerciseIndex: 0,
      repeatTimes: 0, // 口语重做次数
      errMsg: '',
      errCode: 0,
      isContinue: false, // 是否继续人机对话 (当人机对话出现多个)
      isShowAnswerCard: false,
      filterResult: [],
    };
  },
  computed: {
    isExam() {
      return this.type === 'test' || this.type === 'drill';
    },
    secondsToTime() {
      return utils.secondsToTime(this.seconds);
    },
    isSelectWord() {
      return this.currentExercise.code === 'CHXZ' && this.currentExercise.mode === 2;
    },
    isSceneReady() {
      return this.scene === SCENE.ready;
    },
    isSceneExamList() {
      return this.scene === SCENE.examList;
    },
    isSceneFinished() {
      return this.scene === SCENE.finished;
    },
    isSceneError() {
      return this.scene === SCENE.error;
    },
    isScenePlaying() {
      return this.scene === SCENE.playing;
    },
    isSceneKyView() {
      return this.scene === SCENE.kyView;
    },
    isDisabledReplay() {
      return this.score === 100 || this.type === 'drill';
    },
    isShowReplay() {
      return this.type !== 'drill';
    },
    finishedText() {
      return this.isContinue === false ? '完成' : '下一步';
    },
    userAnswer() {
      if (this.results[this.exerciseIndex] && this.isExam) {
        return this.results[this.exerciseIndex].userAnswer || null;
      }
      return null;
    },
    isShowKyDetailView() {
      if (this.currentExercise) {
        const { code, mode } = this.currentExercise;
        return code === 'KY' && mode === 2;
      }
      return false;
    },
    kyExercises() {
      if (this.isShowKyDetailView) {
        return this.newQuizzes.map((quiz) => {
          const { score, record, match } = utils.Array.find(this.result, { id: quiz.id }, 'id') || {};
          return {
            ...quiz,
            score,
            record,
            match,
          };
        });
      }
      return [];
    },
    kyScore() {
      const arr = this.kyExercises.map(exercise => exercise.score || 0);
      let total = 0;
      for (let i = 0; i < arr.length; i += 1) {
        total += arr[i];
      }
      return total / this.kyExercises.length || 0;
    },
    isPass() {
      return this.kyScore >= 1.5;
    },
    isShowCertificate() {
      return this.type === 'drill' && this.score >= 100;
    },
  },
  watch: {
    quizzes() {
      this.reset();
      this.newQuizzes = utils.clone(this.quizzes);
      this.results = this.quizzes.map((item, index) => ({
        ...item,
        index,
        isRight: false,
        userAnswer: item.userAnswer ? JSON.parse(item.userAnswer) : null,
        isComplete: false,
        errorCount: 0,
      }));
      if (this.isExamRecords) {
        this.scene = SCENE.examList;
      } else {
        this.handleAnswerCardData();
      }
    },
    currentExercise() {
      const isOutputAnswer = utils.storage('frontend_nb');
      if (isOutputAnswer) {
        this.outputAnswer();
      }
    },
    scene() {
      // 转场开始计时，试卷除外
      if (this.isScenePlaying) {
        this.startTimer();
      }
    },
  },
  methods: {
    startLearn() {
      this.scene = SCENE.playing;
    },
    startTimer() {
      if (this.timer) {
        this.stopTimer();
      }
      this.timer = setInterval(() => {
        this.seconds += 1;
      }, 1000);
    },
    stopTimer() {
      let val = 0;
      if (this.timer) {
        clearInterval(this.timer);
        val = this.seconds;
        this.timer = 0;
        this.seconds = 0;
      }
      return val;
    },
    exerciseChange({ id, exerciseIndex = 0 }) {
      this.currentExercise = utils.Array.find(this.newQuizzes, { id }, 'id') || {};
      this.exerciseIndex = exerciseIndex;
    },
    handleKyAgain() {
      this.repeatTimes += 1;
      this.reset({
        isResetAll: false,
      });
    },
    handleAnswerCardData() {
      this.answerCardData = [];
      let quiz = this.results[0];
      let site = 0;
      if (quiz) {
        this.answerCardData[site] = {
          code: quiz.code,
          mode: quiz.mode,
          quizzes: [quiz],
        };
      }
      this.results.forEach((item, index) => {
        if (index > 0) {
          if (item.code === quiz.code && item.mode === quiz.mode) {
            this.answerCardData[site].quizzes.push(item);
          } else {
            site += 1;
            quiz = item;
            this.answerCardData[site] = {
              code: item.code,
              mode: item.mode,
              quizzes: [item],
            };
          }
        }
      });
    },
    handleKySubmit() {
      if (!this.repeatTimes) {
        this.submit({
          callback: () => {
            this.$emit('continue');
          },
        });
      } else {
        this.$emit('continue');
      }
    },
    handleKyContinue() {
      this.submit({
        callback: () => {
          this.$emit('continue');
        },
      });
    },
    handleChange(payload) {
      this.results.forEach((item) => {
        if (item.id === payload.id && item.code === payload.code && item.mode === payload.mode) {
          item.isRight = payload.isRight;
          item.isComplete = payload.isComplete;
          item.userAnswer = utils.clone(payload.userAnswer);
        }
      });
      utils.Array.pushReplace(this.result, payload, 'id');
    },
    backFinishedScene() {
      if (this.isExamRecords) {
        this.$emit('close');
        return;
      }
      this.scene = SCENE.finished;
      this.isShowAnswerCard = true;
    },
    handleFinished({ results }) {
      if (this.isShowKyDetailView && this.type !== 'level') {
        this.scene = SCENE.kyView;
        if (!this.repeatTimes && !this.isPass) {
          return;
        }
      }

      if (this.type === 'active_review' || this.type === 'bdc_review') {
        this.submit({ results });
      } else {
        this.submit();
      }
    },
    submit({ callback, results } = {}) {
      this.retry = () => {
        this.submit(callback);
      };

      const seconds = this.stopTimer();
      const data = results || this.result.map(result => ({
        id: result.id,
        parentId: result.parentId,
        isRight: utils.isUndefined(result.isRight) ? true : result.isRight,
        answer: utils.isNumber(result.score) ? result.score : result.score || '',
        status: result.errorCount ? 0 : 1,
        code: result.code,
        errorCount: result.errorCount,
      }));
      /* eslint-disable */
      this.$emit('submit', {
        data,
        seconds,
        mode: this.type,
        callback: ({ isContinue }) => {
          this.isContinue = isContinue;
          if (isContinue) {
            if (!this.isShowKyDetailView) {
              this.$emit('continue');
            }
          } else {
            if (!this.isShowKyDetailView) {
              this.close();
            }
            this.$emit('refresh');
          }
          callback && callback();
        },
      });
    },
    submitExam() {
      const seconds = this.stopTimer();
      const data = this.results.map(result => ({
        id: result.id,
        parentId: result.parentId,
        status: result.isRight ? 1 : 0,
        errorCount: result.isRight ? 0 : 1,
        answer: result.userAnswer ? utils.toJson(result.userAnswer) : '',
      }));

      const emitted = (isRetry) => {
        this.$emit('submit', {
          data,
          seconds,
          // type: this.type,
          type: this.learnMode === 'fallible' ? 'fallible' : this.type,
          mode: this.mode,
          callback: ({ score, isContinue }) => {
            this.isContinue = isContinue;
            if (score) {
              this.score = score;
            }
            if (isRetry) {
              this.scene = SCENE.finished;
            }
          },
        });
      };

      this.retry = () => {
        emitted(true);
      };

      emitted();
    },
    open() {
      this.$refs.dialog.open();
      this.$nextTick(() => {
        this.bindEnterEvent();
      });
    },
    close() {
      this.scene = SCENE.empty;
      this.isShowAnswerCard = false;
      this.$emit('close');
      this.currentExercise = {};
      this.unBindEnterEvent();
    },
    replay() {
      this.newQuizzes = this.results.filter((item) => {
        return !item.isRight;
      });
      this.newQuizzes.forEach((item, index) => {
        item.isRight = false;
        item.userAnswer = null;
        item.isComplete = false;
        item.index = index;
       });
      this.results = utils.clone(this.newQuizzes);
      this.handleAnswerCardData();
      this.isShowAnswerCard = false;
      this.exerciseIndex = 0;
      this.mode = 'replay';
      this.startLearn();
    },
    finishedExam() {
      this.isShowAnswerCard = false;
      if (this.isContinue) {
        this.$emit('continue', this.learnMode);
      } else {
        this.close();
        this.$emit('refresh');
      }
    },
    reset({ scene = SCENE.ready, isResetAll = true } = {}) {
      this.scene = scene;
      this.result = [];
      this.exerciseIndex = 0;
      this.mode = '';
      if (isResetAll) {
        this.repeatTimes = 0;
      }
    },
    error({ code, message } = {}) {
      this.scene = SCENE.error;

      if (code) {
        this.errMsg = message;
        this.errCode = code;
      } else {
        this.errMsg = '';
        this.errCode = 0;
      }
    },
    outputAnswer() {
      const {
        code,
        answer,
        text,
        answerIndex,
        options,
        parts,
        items,
      } = this.currentExercise;
      let output;
      switch (code) {
        case 'JXZH':
          output = answer;
          break;
        case 'TYLJ':
        case 'QHLJ':
          output = text;
          break;
        case 'DX':
          output = options[answerIndex];
          break;
        case 'BQWZ':
          output = parts.map(part => `${part.answer}`).join('\n');
          break;
        case 'YDLJ':
        case 'XCTK':
        case 'THXZ':
        case 'WXTK':
          output = items.map(item => `${item.answer}`).join('\n');
          break;
        default:
          break;
      }
      if (output) {
        const style = 'background: green; color:#fff;';
        console.log('%c answer =>', style, output);
      }
    },
    getGlobalQuizIndex(index, offset) {
      return this.answerCardData
        .slice(0, index)
        .reduce((pre, cur) => pre.concat(cur.quizzes), [])
        .length + offset;
    },
    selectExercise(index) {
      if (this.isSceneFinished) {
        this.scene = SCENE.examList;
        this.$nextTick(() => {
          this.setAnchor(index);
        });
      } else {
        this.$refs.controller.exerciseIndex = index;
      }
      this.isShowAnswerCard = !this.isShowAnswerCard;
    },
    handleSubmitExamBtn() {
      clearInterval(this.timer);
      this.submitExam();
      this.scene = SCENE.finished;
    },
    setAnchor(index) {
      const { code } = this.results[index];
      this.$refs.examList.setAnchor(index, {
        autoPlay: code !== 'THXZ',
      });
      this.isShowAnswerCard = false;
    },
    detail() {
      this.isShowAnswerCard = !this.isShowAnswerCard;
    },
    prev() {
      this.$refs.controller.prev();
    },
    next(type) {
      if (this.currentExercise.code === 'QHLJ' && type === 'text') return;
      if (this.currentExercise.code === 'XCTK' && type === 'text') {
        const { id } = this.currentExercise;
        const { isComplete } = utils.Array.find(this.result, { id }, 'id') || {};
        if (!isComplete) return;
      }
      this.$nextTick(() => {
        this.$refs.controller.next(type);
        this.$refs.wrap.scrollTop = 0;
      });
    },
    speak() {
      this.$refs.controller.speak();
    },
    clear() {
      this.$refs.controller.clear();
    },
    handleGlobalEnter(event) {
      if (this.isShowAnswerCard) return;
      if (this.isSceneReady && event.keyCode === 13) {
        this.scene = SCENE.playing;
      }
      if (!this.isScenePlaying) return;
      if (event.keyCode === 13 && this.isExam) {
        const obj = event.target || event.srcElement; // 获取事件源
        const type = obj.type || obj.getAttribute('type');
        this.next(type);
      }
    },
    bindEnterEvent() {
      document.addEventListener('keyup', this.handleGlobalEnter);
    },
    unBindEnterEvent() {
      document.removeEventListener('keyup', this.handleGlobalEnter);
    },
    openCertificate() {
      this.$emit('openCertificate');
    },
    handlerFilterResult(isCheckAll) {
      if (!isCheckAll) {
        this.filterResult = this.results.filter(item => !item.isRight);
      } else {
        this.filterResult = [];
      }
    },
  },
  created() {
    this.retry = () => {};
  },
  mounted() {
    this.bindEnterEvent();
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import '@/styles/common/tip-line.scss';

  .quizzes-wrapper {
    width: 100%;
    height: 80%;
    overflow-y: auto;
    color: #fff;
    user-select: none;
    .bkw-dialog-wrap {
      height: 100%;
      .ready {
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #fff;
        .description {
          font-weight: 500;
          font-size: 16px;
        }
        .button-wrapper {
          display: flex;
          justify-content: center;
        }
        .el-button {
          min-width: 120px;
        }
      }
      .time {
        position: absolute;
        top: 10px;
        right: 0;
        transform: translateX(-50%);
        font-size: 22px;
        color: $primary;
      }
      .finished {
        height: 100%;
      }
      .tip-line {
        margin-top: 20px;
      }
    }
    .exam-control {
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      padding: 5px 20px;
      width: 100%;
      /deep/ .button-wrap {
        display: flex;
        .footer-button-wrapper {
          display: flex;
          button {
            margin: 0 10px 0 0;
          }
        }
      }
    }
    .answer-card {
      .detail {
        margin-top: -20px;
        padding: 0 40px 20px;
        display: flex;
        flex-wrap: wrap;
        height: calc(100% - 158px);
        overflow-y: auto;
        .item {
          width: 100%;
          padding-bottom: 5px;
          border-bottom: 1px solid #eee;
          text-align: left;
          .tag {
            margin: 20px 0 5px 10px;
            text-align: left;
          }
          .number {
            cursor: pointer;
            display: inline-block;
            width: 40px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            margin: 10px;
            font-weight: bold;
            border-radius: 50%;
            color: $primary;
            border: 1px solid $primary;
            &.filled {
              color: #fff;
              background-color: $primary;
            }
            &.danger {
              color: #fff;
              background-color: $danger;
              border: 1px solid $danger;
            }
            &.success {
              color: #333;
              background-color: #b8dfff;
              border: 1px solid #b8dfff;
            }
          }
        }
      }
      .exam-detail {
        height: calc(100% - 290px);
      }
    }
  }
</style>
